import { matchPath } from 'react-router-dom';

const APP_NAME = 'SYSTAGIO';

/** Rotas mais específicas primeiro (matchPath para na primeira correspondência). */
const ROUTE_TITLES: { pattern: string; title: string }[] = [
  { pattern: '/login', title: 'Login' },
  { pattern: '/register', title: 'Cadastro' },

  { pattern: '/admin/planos', title: 'Planos' },
  { pattern: '/admin/usuarios', title: 'Usuários' },
  { pattern: '/admin/perfil', title: 'Meu perfil' },
  { pattern: '/admin', title: 'Painel administrativo' },

  { pattern: '/alunos/novo', title: 'Novo aluno' },
  { pattern: '/alunos/:id/editar', title: 'Editar aluno' },
  { pattern: '/alunos/:id', title: 'Detalhes do aluno' },
  { pattern: '/alunos', title: 'Alunos' },

  { pattern: '/empresas/nova', title: 'Nova empresa' },
  { pattern: '/empresas/:id/editar', title: 'Editar empresa' },
  { pattern: '/empresas', title: 'Empresas' },

  { pattern: '/cidades/nova', title: 'Nova cidade' },
  { pattern: '/cidades/:id/editar', title: 'Editar cidade' },
  { pattern: '/cidades', title: 'Cidades' },

  { pattern: '/cursos/novo', title: 'Novo curso' },
  { pattern: '/cursos/:id/editar', title: 'Editar curso' },
  { pattern: '/cursos', title: 'Cursos' },

  { pattern: '/estagios/novo', title: 'Novo estágio' },
  { pattern: '/estagios/:id/editar', title: 'Editar estágio' },
  { pattern: '/estagios/:id', title: 'Detalhes do estágio' },
  { pattern: '/estagios', title: 'Estágios' },

  { pattern: '/instituicoes/nova', title: 'Nova instituição' },
  { pattern: '/instituicoes/:id/editar', title: 'Editar instituição' },
  { pattern: '/instituicoes', title: 'Instituições' },

  { pattern: '/seguradoras/nova', title: 'Nova seguradora' },
  { pattern: '/seguradoras/:id/editar', title: 'Editar seguradora' },
  { pattern: '/seguradoras', title: 'Seguradoras' },

  { pattern: '/agentes-integradores/novo', title: 'Novo agente integrador' },
  { pattern: '/agentes-integradores/:id/editar', title: 'Editar agente integrador' },
  { pattern: '/agentes-integradores', title: 'Agentes Integradores' },

  { pattern: '/horarios/novo', title: 'Novo horário' },
  { pattern: '/horarios/:id/editar', title: 'Editar horário' },
  { pattern: '/horarios/estagio/:estagioId', title: 'Horários do estágio' },
  { pattern: '/horarios', title: 'Horários' },

  { pattern: '/relatorios/novo', title: 'Novo relatório' },
  { pattern: '/relatorios/:id/editar', title: 'Editar relatório' },
  { pattern: '/relatorios/personalizados', title: 'Relatório Personalizado' },
  { pattern: '/relatorios/gerenciar', title: 'Gerenciar Relatórios' },
  { pattern: '/relatorios', title: 'Relatórios de Estágio' },

  { pattern: '/termo-contrato', title: 'Termo de Estágio' },
  { pattern: '/termo-rescisao', title: 'Termo de Rescisão' },
  { pattern: '/configuracao-termo', title: 'Configuração de Termo' },
  { pattern: '/perfil', title: 'Meu perfil' },

  { pattern: '/', title: 'Dashboard' },
];

export function getPageTitle(pathname: string): string {
  for (const { pattern, title } of ROUTE_TITLES) {
    if (matchPath({ path: pattern, end: true }, pathname)) {
      return `${APP_NAME} - ${title}`;
    }
  }

  return APP_NAME;
}

export { APP_NAME };
